import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UtilsService } from 'src/app/core/utils.service';
import { Buyer, BuyerOrigin, CommChannel } from 'src/app/core/buyers.service';
import { DialogService } from 'src/app/core/dialog.service';
import { ErrorService, SplittypayError } from 'src/app/core/error.service';

@Component({
  selector: 'app-buyer-details-general-info',
  templateUrl: './buyer-details-general-info.component.html',
  styleUrls: ['./buyer-details-general-info.component.scss'],
})
export class BuyerDetailsGeneralInfoComponent {
  @Input() buyer?: Buyer;
  @Input() contract_id?: string;
  @Output() refresh: EventEmitter<void> = new EventEmitter<void>();

  constructor(private utils_service: UtilsService) {}

  getOnboardingStatus(): string {
    if (this.buyer) return this.utils_service.getOnboardingStatus(this.buyer);
    else return '';
  }

  getFullName(): string {
    if (this.buyer) {
      const full_name = `${this.buyer.firstname} ${this.buyer.lastname}`;
      if (full_name.length > 30) {
        return full_name.slice(0, 27) + '...';
      } else {
        return full_name;
      }
    } else {
      return '-';
    }
  }

  getStoreFullName(): string {
    if (this.buyer && this.buyer.origin_store_name) {
      if (this.buyer.origin_store_name.length > 30) {
        return this.buyer.origin_store_name.slice(0, 27) + '...';
      } else {
        return this.buyer.origin_store_name;
      }
    } else {
      return '-';
    }
  }

  getFormattedPhone(): string {
    if (!this.buyer?.phone) {
      return '-';
    }

    return this.buyer.phone.prefix + ' ' + this.buyer.phone.value;
  }

  onChatClick(): void {
    const phone_number = `${this.buyer?.phone?.prefix}${this.buyer?.phone?.value}`.replace(/\s/g, '');
    const whatsapp_url = `https://wa.me/${phone_number}`;
    window.open(whatsapp_url, '_blank');
  }

  getCommunicationChannel(): string {
    let communication_channel = '-';
    if (!this.buyer?.communication_channel) {
      return communication_channel;
    }

    switch (this.buyer.communication_channel) {
      case CommChannel.digital:
        communication_channel = 'BUYERS.DIGITAL_COMMUNICATION_CHANNEL_LABEL';
        break;
      case CommChannel.paper:
        communication_channel = 'BUYERS.PAPER_COMMUNICATION_CHANNEL_LABEL';
        break;
      default:
        communication_channel = '-';
        break;
    }

    return communication_channel;
  }

  getOriginLabel(): string {
    if (this.buyer?.origin) {
      return this.utils_service.getBuyerOriginLabel(this.buyer.origin as BuyerOrigin);
    } else {
      return '-';
    }
  }
}
